import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';
import htmlWrapper from '../assets/email_template.html?raw';
import textWrapper from '../assets/email_template.txt?raw';

export default function useMailTemplate() {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const getTemplateById = async templateId => {
    return await sendRequest({
      url: `/api/v1/mailTemplate/${templateId}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  const updateTemplate = async (templateId, body) => {
    return await sendRequest({
      url: `/api/v1/mailTemplate/${templateId}`,
      method: 'PATCH',
      headers: authCtx.getAuthHeaders(),
      body,
    });
  };

  const getEmailWrappers = () => {
    return { htmlWrapper, textWrapper };
  };

  return { getTemplateById, updateTemplate, getEmailWrappers };
}
